import { render, staticRenderFns } from "./dashboard-big-number-b.vue?vue&type=template&id=67c9bb9a&scoped=true&"
import script from "./dashboard-big-number-b.vue?vue&type=script&lang=js&"
export * from "./dashboard-big-number-b.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-big-number-b.vue?vue&type=style&index=0&id=67c9bb9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9bb9a",
  null
  
)

export default component.exports